import { FormGroup, FormBuilder } from '@angular/forms';
import { FormEt004Build } from './forms-build/form-et004-build';

export class FormEt004 extends FormEt004Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            site_tratamento: ['', []],
            safra: ['', []],
            ca_tratamento_controle_analise: ['', []],
            // data_tratamento: ['', []],
            // tipo_produto: ['', []],
            hibrido: ['', []],
            peneira: ['', []],
            origem_lote_ou_tulha: ['', []],
            umidade: ['', []],
            tipo_tratamento: ['', []],
            peso_10_mil_sementes_g: ['', []],
            numero_sementes_contador: ['', []],
            numero_sementes_por_kg: ['', []],
            data_hr_da_contagem_60_mil_sementes: ['', []],
            peso_liquido_regulagem_cbt_200_kg: ['', []],
            pump_station_calda_convencional: ['', []],
            pump_station_calda_tsi: ['', []],
            pump_station_calda_poncho: ['', []],
            pump_station_calda_dermacor: ['', []],
            // pump_station_calda_derosal_plus: ['', []],
            pump_station_redigo: ['', []],
            talkum_gloss: ['', []],
            //correcao_de_aplicacao: ['', []],
            correcao_aplicacao_poncho: ['', []],
            // correcao_aplicacao_cruiser: ['', []],
            correcao_aplicacao_redigo: ['', []],
            correcao_aplicacao_dermacor: ['', []],
            peso_de_mil_sementes_kg: ['', []],
            poncho_g_por_kg: ['', []],
            // cruiser_g_por_kg: ['', []],
            // cruiser: ['', []],
            redigo_g_por_kg: ['', []],
            dermacor_g_por_kg: ['', []],
            //derosal_plus_g_por_kg: ['', []],
            polimero_l_por_t: ['', []],
            agua_l_por_t: ['', []],
            calda_convencional_l_por_t: ['', []],
            id_calda_base: ['', []],
            liberacao_da_receita: ['', []],
            inicio_tratamento: ['', []],
            termino_tratamento: ['', []],
            linha_tratamento: ['', []],
            nr_tulha_ou_silo_tratamento_destino: ['', []],
            velocidade_do_bowl: ['', []],
            tempo_descarga_inicio_seg: ['', []],
            tempo_descarga_duracao_seg: ['', []],
            batelada_kg: ['', []],
            peso_total_lote_tratado_kg: ['', []],
            peso_impressao_pos_tratamento_kg: ['', []],
            consumo_poncho_ml_por_sc: ['', []],
            // consumo_cuiser_ml_por_sc: ['', []],
            consumo_dermacor_ml_por_sc: ['', []],
            //  consumo_derosal_ml_por_sc: ['', []],
            consumo_talkum_gloss_g_por_kg: ['', []],
            consumo_redigo_ml_por_sc: ['', []],
            responsavel_tratamento: ['', []],
            velocidade_esteira_hz_ou_porct: ['', []],
            unidade_medida_vel_esteira: ['', []],
            temperatura_c: ['', []],
            lote_fng: ['', []],
            observacao: ['', []],
            offline: true,
            // lote_cs: ['', []],
            ca_limpeza: ['', []],
            ingrediente_ativo_laudo_produto_dermacor: ['', []],
            ingrediente_ativo_laudo_produto_poncho: ['', []],
            // ingrediente_ativo_laudo_produto_redigo: ['', []],
            // ingrediente_ativo_laudo_produto_cruiser: ['', []],
            correcao_total: ['', []],
            turno: ['', []],
            lote_pos_limpeza_de_linha: ['', []],
            correcao_limpeza_linha: ['', []],
            correcao_ia_poncho: ['', []],
            correcao_perda_processo_poncho: ['', []],
            correcao_ia_dermacor: ['', []],
            correcao_perda_processo_dermacor: ['', []],
            correcao_perda_processo_redigo: ['', []],
            polimero_list: ['', []],
            calda_tsi: ['', []],

            created_by: ['', []],
        });
        return formulario;
    }
}
